import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
} from '@mui/material'
import EditIcon from '../../../../assets/icons/Edit/Edit.svg'
import CustomInput from '../../../../components/muiComponents/customInput'
import { H6 } from '../../../../layouts/TextStyles'
import { groupApiSlice } from '../../../../features/group/groupSlice'
import SingleSelect from '../../../../components/muiComponents/singleSelect'

interface Props {
    fullName: string
    courseSubjectId: number
    language: string
    courseUserEnrollId: number
}

const EditGroupStudentDialog: React.FC<Props> = ({
    fullName,
    courseSubjectId,
    language,
    courseUserEnrollId,
}) => {
    const { formatMessage } = useIntl()
    const { groupId } = useParams()
    const [openDialog, setOpenDialog] = useState(false)
    const [selectedGroup, setSelectedGroup] = useState(Number(groupId))
    const { data: groups = [] } = groupApiSlice.useGetGroupsForStudentQuery(
        {
            subjectIds: [courseSubjectId],
            languageEnum: language,
        },
        { skip: !openDialog },
    )
    const [addStudentToGroup, { isLoading }] =
        groupApiSlice.useAddStudentToGroupMutation()

    const handleAddStudentToGroup = async () => {
        try {
            await addStudentToGroup({
                courseUserEnrollId,
                studentGroupId: selectedGroup,
                courseSubjectId
            }).unwrap()
            toast.success(formatMessage({ id: 'savedSuccess' }))
        } catch (error) {}
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
    }
    const handleClickOpen = () => {
        setOpenDialog(true)
    }

    return (
        <div>
            <IconButton
                sx={{ background: '#f3f4f5' }}
                onClick={handleClickOpen}
            >
                <img
                    src={EditIcon}
                    alt="edit"
                />
            </IconButton>

            <Dialog
                maxWidth={'sm'}
                fullWidth
                open={openDialog}
                onClose={handleCloseDialog}
            >
                <DialogTitle id="responsive-dialog-title">
                    {formatMessage({ id: 'editData' })}
                </DialogTitle>

                <DialogContent>
                    <Box mb={2}>
                        <H6>{formatMessage({ id: 'fullName' })}</H6>

                        <CustomInput
                            id="fullName"
                            name="fullName"
                            placeholder={formatMessage({
                                id: 'fullName',
                            })}
                            fullWidth
                            value={fullName}
                            disabled={true}
                            margin="dense"
                        />
                    </Box>

                    <Box mb={2}>
                        <H6>{formatMessage({ id: 'group' })}</H6>

                        <SingleSelect
                            id="groupId"
                            name="groupId"
                            placeholder={formatMessage({
                                id: 'group',
                            })}
                            value={selectedGroup}
                            handleChange={(e) =>
                                setSelectedGroup(e.target.value)
                            }
                            menuItems={[{ id: '', title: '-' }].concat(groups)}
                        />
                    </Box>
                </DialogContent>

                <DialogActions sx={{ m: 2 }}>
                    <Button
                        onClick={handleCloseDialog}
                        variant={'outlined'}
                        sx={{ mr: 1 }}
                        disabled={isLoading}
                    >
                        {formatMessage({ id: 'cancel' })}
                    </Button>

                    <Button
                        variant={'contained'}
                        sx={{ width: '120px' }}
                        onClick={() => handleAddStudentToGroup()}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <CircularProgress
                                size={20}
                                style={{ marginRight: '8px' }}
                            />
                        ) : (
                            formatMessage({ id: 'save' })
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default EditGroupStudentDialog
